<div class="no-case-selected-overlay-message">
    <div class="section-subhead no-case-selected-overlay-message-header">Select a Client</div>
    <p>To continue, select a client from the dropdown at the top of the page.</p>
</div>